import { StoreGroup } from "../../types/pivot.type";

/**
 * The channel groups to show under a product row opened inside product-view group
 * `groupKey`.
 *
 * The product view groups its rows by the same channel code the drill groups stores by, so
 * a product sold in three channels sits under three group headings. Opening it under one of
 * them shows only that channel's stores — the numbers then add up to the row that was
 * clicked, not to the product's total across channels. That slice can be empty: the product
 * had lines in the channel but no store there sold any. A flat product view has no channel
 * of its own and shows the whole channel → store tree.
 */
export const channelsForProductRow = (
  groups: StoreGroup[],
  groupKey: string,
  isFlat: boolean,
): StoreGroup[] => (isFlat ? groups : groups.filter((g) => g.group.key === groupKey));
